import React, { useRef } from "react";

interface Condition {
  tabName: string;
  appointmentMemberTotalCount: number;
  chargeMemberTotalCount: number;
  entranceMemberTotalCount: number;
  onClickTab: any;
}

const Condition = ({
  tabName,
  appointmentMemberTotalCount,
  chargeMemberTotalCount,
  entranceMemberTotalCount,
  onClickTab,
}: Condition) => {
  const line = useRef<HTMLDivElement>(null);
  const conditionWrap = useRef<HTMLDivElement>(null);

  const handleClickTab = (name: string, index: number) => {
    if (tabName === name) return;
    onClickTab(name);
    const condition = conditionWrap.current?.querySelectorAll(".condition")[0];
    line.current!.style.marginLeft = condition!.clientWidth * index + "px";
  };

  return (
    <div>
      <div className="member-mngt-condition" ref={conditionWrap}>
        <div
          className={`condition ${tabName === "APPOINTMENT" && "active"}`}
          onClick={() => handleClickTab("APPOINTMENT", 0)}
        >
          개인레슨 <span>{appointmentMemberTotalCount}</span>
        </div>
        <div
          className={`condition ${tabName === "CHARGE" && "active"}`}
          onClick={() => handleClickTab("CHARGE", 1)}
        >
          관리담당 <span>{chargeMemberTotalCount}</span>
        </div>
        <div
          className={`condition ${tabName === "ENTRANCE" && "active"}`}
          onClick={() => handleClickTab("ENTRANCE", 2)}
        >
          입장중 <span>{entranceMemberTotalCount}</span>
        </div>
      </div>
      <div className="line-warp">
        <div className="active-line" ref={line}></div>
      </div>
    </div>
  );
};

export default Condition;
